import styled from 'styled-components';

export const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`;
export const Text = styled.span`
  font-size: 12px;
`;

export const ContainerInfo = styled.div<{
  padding?: boolean;
  hotelType?: boolean;
}>`
  border-radius: 8px;
  background-color: ${({ theme, hotelType }) =>
    hotelType ? theme.palette.G50 : theme.palette.lightSuccess};
  max-width: 129px;
  height: 32px;
  cursor: pointer;
  display: flex;
  justify-content: center;
`;

export const WrapperInfo = styled.div`
  display: flex;
  padding: 5px;
  align-items: center;
`;

export const ColCustomIcon = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 5px;
`;
export const InfoBadge = styled.span<{
  hotelType?: boolean;
}>`
  font-size: 12px;
  color: ${({ theme, hotelType }) =>
    hotelType ? theme.palette.NL800 : theme.palette.darkSuccess};
  font-weight: ${({ hotelType }) => (hotelType ? 400 : 600)};
  margin-top: 3px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;
